import { render, staticRenderFns } from "./CambiarDatosPasoDos.vue?vue&type=template&id=0d16fe80"
import script from "./CambiarDatosPasoDos.vue?vue&type=script&lang=js"
export * from "./CambiarDatosPasoDos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports